import React, { useState, useEffect } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from '../components/ui/card';
import { toast } from 'sonner';
import { humanizeError } from '../utils/errorHandling';
import { getApiBase } from '../utils/apiBase';
import { AuthPageLayout } from '../components/layout/AuthPageLayout';

const API = getApiBase();

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) {
      toast.error('Invalid or missing reset link.');
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token) return;
    if (password !== confirm) {
      toast.error('Passwords do not match.');
      return;
    }
    if (password.length < 8) {
      toast.error('Use at least 8 characters.');
      return;
    }
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/reset-password`, { token, password });
      toast.success(data?.message || 'Password updated.');
      navigate('/login', { replace: true });
    } catch (error) {
      toast.error(humanizeError(error));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthPageLayout>
          <Card className="rounded-2xl border border-[#e8e2d8]/90 bg-[#fffcf7]/95 shadow-sm">
            <CardHeader>
              <CardTitle className="font-serif text-xl font-normal">Choose a new password</CardTitle>
              <CardDescription>This link expires after one hour.</CardDescription>
            </CardHeader>
            <CardContent>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="space-y-2">
                  <Label htmlFor="np">New password</Label>
                  <Input
                    id="np"
                    type="password"
                    autoComplete="new-password"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="border-[#e8e2d8] bg-white/90"
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="npc">Confirm password</Label>
                  <Input
                    id="npc"
                    type="password"
                    autoComplete="new-password"
                    required
                    value={confirm}
                    onChange={(e) => setConfirm(e.target.value)}
                    className="border-[#e8e2d8] bg-white/90"
                  />
                </div>
                <Button type="submit" className="w-full rounded-full" disabled={loading || !token}>
                  {loading ? 'Saving…' : 'Update password'}
                </Button>
              </form>
            </CardContent>
            <CardFooter>
              <Link to="/login" className="text-sm text-[#5c4a32] underline underline-offset-2">
                Back to sign in
              </Link>
            </CardFooter>
          </Card>
    </AuthPageLayout>
  );
};

export default ResetPassword;
